import { Router } from '@angular/router/router';
import {
  CheckoutState,
  InterruptionControlParameters,
  ResolveType,
  StateControlParameters,
  StateService,
} from '@app/service/state/state.service';
import { ActivatedRoute } from '@angular/router';
import { DeBaseComponent } from '@app/route/DE/de-base-component/de-base.component';
import { HeaderService } from '@app/service/header/header.service';
import { StandardCheckoutResponse } from '@app/service/user-service/user.service';
import { AtRoute, DeRoute } from '@assets/val/route-constants';

export class RouteComponent extends DeBaseComponent {
  public state: CheckoutState;
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService
  ) {
    super();
    this.state = this.route.snapshot.data['state'];

    if (this.state?.forceNavigation) {
      const route: string = this.stateService.getRouteFromState(this.state);
      // Guard against navigating to the route we are already on. Without this check, any page where
      // the backend returns forceNavigation=true (e.g. SUCCESS after completion, or any page after a
      // refresh/back-navigation where the server decides the user should stay put) can cause
      // router.navigate() to re-trigger the StateResolver. 
      const currentUrlPath = this.router.url.replace(/^\/+/, '');
      const currentPageName = this.stateService.getStepFromUrl(currentUrlPath);
      if (currentPageName !== this.state.currentPageInformation.pageName) {
        this.router.navigate([route], { queryParamsHandling: 'preserve' });
      }
    }

    if (!this.state) {
      this.internalServerError = true;
    }
  }

  async navigate(): Promise<void> {
    try {
      const controlParams: StateControlParameters = {
        currentPageName: this.stateService.getStepFromUrl(
          this.router.url.replace(/^\/+/g, '')
        ),
        token: this.stateService.getToken(),
      };

      let updatedState = await this.stateService.navigate(controlParams);

      // TODO: this is a ugly hack to be able to present loanTerms on the CONFIRM_TOKENIZED_PAYMENT page,
      // this logic should be done in backend
      // Edit: Added same scuffed logic for AT
      if (
        updatedState.currentPageInformation.pageName ===
          DeRoute.CONFIRM_TOKENIZED_PAYMENT ||
        updatedState.currentPageInformation.pageName ===
          AtRoute.CONFIRM_TOKENIZED_PAYMENT
      ) {
        const resp: StandardCheckoutResponse =
          await this.stateService.applyForTokenizedPayment();
        if (resp.error || resp.rejected) {
          updatedState = await this.stateService.navigate(controlParams);
        }
      }

      const route = this.stateService.getRouteFromState(updatedState);
      // Don't navigate if already on the correct page
      const currentPageName = this.stateService.getStepFromUrl(this.router.url.replace(/^\/+/, ''));
      if (currentPageName !== updatedState.currentPageInformation.pageName) {
        this.router.navigate([route], {
          queryParams: {
            // Never preserve these params:
            transaction_id: null,
            success: null,
          },
          queryParamsHandling: 'merge',
        });
      }
    } catch (err) {
      this.handleError(err);
    }
  }

  async reset(): Promise<void> {
    const path: string = this.route.routeConfig.path;
    const controlParams: StateControlParameters = {
      currentPageName: this.stateService.getStepFromUrl(
        path.replace(/^\/+/g, '')
      ),
      token: this.stateService.getToken(),
    };

    const updatedState = await this.stateService.reset(controlParams);
    const route = this.stateService.getRouteFromState(updatedState);
    this.router.navigate([route], { queryParamsHandling: 'preserve' });
  }

  async resolveInterruption(resolveType: ResolveType) {
    const controlParams: InterruptionControlParameters = {
      currentPageName: this.stateService.getStepFromUrl(
        this.router.url.replace(/^\/+/g, '')
      ),
      token: this.stateService.getToken(),
      resolveType: resolveType,
    };

    const updatedState = await this.stateService.resolveInterruption(
      controlParams
    );
    const route = this.stateService.getRouteFromState(updatedState);
    // Don't navigate if already on the correct page
    const currentPageName = this.stateService.getStepFromUrl(this.router.url.replace(/^\/+/, ''));
    if (currentPageName !== updatedState.currentPageInformation.pageName) {
      this.router.navigate([route], { queryParamsHandling: 'preserve' });
    }
  }
}
